<template>
	<div class="microSuper" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="智能微超招商" right-text="分享" @click-right="applyMerchantShare" :fixed="true" />
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
         		<img src="../../assets/advDetail/microSuper/top.png" />
				<img src="../../assets/advDetail/microSuper/top_m.png" />
				<img src="../../assets/advDetail/microSuper/bottom_mx.png" />
				<img src="../../assets/advDetail/microSuper/bottom.png" />
			</van-col>
		</van-row>
		<p>
			<a class="btn" href="tel:18634765757" @click="iOStel()">
				<img src="../../assets/advDetail/microSuper/btn.png" />
			</a>
		</p>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
    	tel: '',
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
	iOStel() {
		let ua = navigator.userAgent.toLowerCase();
		if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
	        this.phone();
	    }
	},
	phone() {
		this.tel = '18634765757';
		this.params(this.tel, this.tel, 'phone');
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  },
  mounted() {
	
  }
};
</script>

<style lang="less">
.microSuper {
	background: #3F99FF;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	    	color: #333;
	    	font-size: 17px;
	    	font-weight: 700;
		}
		.van-nav-bar__text {
			color: #555;
	    	font-size: 16px;
	    	font-weight: 400;
		}
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.content{
		background: #ffd0e0;
		img{
			width: 100%;
			display: block;
		}
	}
	p{
		padding: 9px 17px 13px;
		position: fixed;
		bottom: 0;
		left: 0;
		background: #3F99FF;
		img {
			width: 100%;
			display: block;
		}
	}
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
